export const SET_VIDEO_CATEGORIES = 'SET_VIDEO_CATEGORIES';
export const SET_VIDEO_CATEGORIES_MOVEMENT = 'SET_VIDEO_CATEGORIES_MOVEMENT';
export const SET_VIDEO_CATEGORIES_ASSESSMENT = 'SET_VIDEO_CATEGORIES_ASSESSMENT';
export const CLEAR_VIDEO_CATEGORIES = 'CLEAR_VIDEO_CATEGORIES';
export const SET_PARENT_VIDEO_CATEGORIES = 'SET_PARENT_VIDEO_CATEGORIES';
